var map = {
	"./10-12-2020-v2/1024/img/Body_Normal.png": "07a3",
	"./10-12-2020-v2/2048/img/Body_Normal.png": "46cb",
	"./10-12-2020-v2/512/img/Body_Normal.png": "ac4c",
	"./10-12-2020-v3/1024/img/Body_Normal.png": "e9d7",
	"./10-12-2020-v3/2048/img/Body_Normal.png": "3a9c",
	"./10-12-2020-v3/512/img/Body_Normal.png": "f1a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a2a";